import React from "react";
import { Link } from "react-router-dom";
import { ArrowUp, ChevronRight, MessageCircle } from "lucide-react";

const Footer = () => {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    const scrollToGames = () => {
        const gamesSection = document.getElementById("games");

        if (gamesSection) {
            gamesSection.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        } else {
            window.location.href = "/#games";
        }
    };

    const games = [
        {
            name: "Pubg Mobile UC",
            path: "/pubg",
        },
        {
            name: "FreeFire Diamond",
            path: "/freeFire",
        },
        {
            name: "Mobile Legends",
            path: "/mobileLegends",
        },
        {
            name: "TikTok JETON",
            path: "/tiktok",
        },
        {
            name: "Telefon FANLAR",
            path: "/mobileAccessory",
        },
    ];


    return (
        <footer className="relative w-full overflow-hidden border-t border-black/[0.06] bg-white text-slate-900 dark:border-white/[0.06] dark:bg-[#050507] dark:text-white">

            {/* =====================================================
                BACKGROUND EFFECTS
            ===================================================== */}

            <div className="pointer-events-none absolute inset-0 overflow-hidden">

                {/* top glow */}
                <div className="absolute -left-32 -top-32 h-80 w-80 rounded-full bg-fuchsia-500/[0.05] blur-3xl dark:bg-fuchsia-600/[0.08]" />

                <div className="absolute -bottom-40 right-[-100px] h-96 w-96 rounded-full bg-cyan-500/[0.05] blur-3xl dark:bg-cyan-500/[0.07]" />

                {/* grid */}
                <div
                    className="
                        absolute
                        inset-0
                        opacity-[0.025]
                        [background-image:linear-gradient(rgba(0,0,0,.35)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,.35)_1px,transparent_1px)]
                        [background-size:28px_28px]
                        dark:opacity-[0.035]
                        dark:[background-image:linear-gradient(rgba(255,255,255,.35)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.35)_1px,transparent_1px)]
                    "
                />
            </div>

            {/* top gradient line */}
            <div className="pointer-events-none absolute left-0 right-0 top-0 h-px bg-gradient-to-r from-transparent via-fuchsia-500/70 to-transparent" />

            {/* =====================================================
                MAIN FOOTER
            ===================================================== */}

            <div className="relative mx-auto w-full max-w-7xl px-5 py-12 sm:px-6 sm:py-14 lg:px-8">

                {/* brand / top row */}
                <div className="mb-10 flex flex-col gap-5 border-b border-black/[0.06] pb-8 sm:flex-row sm:items-center sm:justify-between dark:border-white/[0.07]">

                    <div>
                        <div className="flex items-center gap-2">
                            <span className="h-1.5 w-1.5 rounded-full bg-fuchsia-500 shadow-[0_0_10px_rgba(217,70,239,.8)]" />

                            <span className="text-[9px] font-black tracking-[0.35em] text-fuchsia-500">
                                FFQADIR AZ
                            </span>
                        </div>

                        <h2 className="mt-2 text-2xl font-black tracking-tight text-slate-900 dark:text-white">
                            PREMIUM GAMING EXPERIENCE
                        </h2>

                        <p className="mt-1 text-[10px] tracking-[0.12em] text-slate-400 dark:text-white/25">
                            OYUN ÖDƏNİŞLƏRİ • SÜRƏTLİ • RAHAT • ETİBARLI
                        </p>
                    </div>

                  
                </div>

                {/* =====================================================
                    FOOTER COLUMNS
                ===================================================== */}

                <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-12">

                    {/* HAQQIMIZDA */}
                    <div>
                        <Link to="/about" className="group mb-5 flex items-center gap-2 transition hover:opacity-80">
                            <span className="h-1.5 w-1.5 rounded-full bg-fuchsia-500 shadow-[0_0_8px_rgba(217,70,239,.8)]" />

                            <h3 className="text-[11px] font-black tracking-[0.2em] text-slate-800 transition group-hover:text-fuchsia-500 dark:text-white dark:group-hover:text-fuchsia-400">
                                HAQQIMIZDA
                            </h3>
                        </Link>

                        <p className="max-w-sm text-[12px] leading-7 text-slate-400 dark:text-white/35">
                            Saytımız Azərbaycanda oyunlara ödəniş etmək istəyən
                            oyunçular üçün rahat və sərfəli qiymətə ödəniş edə
                            biləcəyi bir platformadır.
                        </p>

                     
                    </div>

                    {/* FAYDALI LINKLƏR */}
                    <div>
                        <div className="mb-5 flex items-center gap-2">
                            <span className="h-1.5 w-1.5 rounded-full bg-cyan-400 shadow-[0_0_8px_rgba(34,211,238,.7)]" />

                            <h3 className="text-[11px] font-black tracking-[0.2em] text-slate-800 dark:text-white">
                                FAYDALI LİNKLƏR
                            </h3>
                        </div>

                        <ul className="space-y-3">
                            <li>
                                <button
                                    type="button"
                                    onClick={scrollToGames}
                                    className="
                                        group
                                        flex
                                        items-center
                                        gap-2
                                        text-[11px]
                                        font-medium
                                        tracking-wide
                                        text-slate-400
                                        transition
                                        duration-300
                                        hover:translate-x-1
                                        hover:text-fuchsia-500
                                        dark:text-white/35
                                        dark:hover:text-fuchsia-400
                                    "
                                >
                                    <ChevronRight
                                        size={13}
                                        className="opacity-0 transition group-hover:translate-x-1 group-hover:opacity-100"
                                    />

                                    <span>Oyunlar</span>
                                </button>
                            </li>

                        

                            <li>
                                <Link
                                    to="/note"
                                    className="
                                        group
                                        flex
                                        items-center
                                        gap-2
                                        text-[11px]
                                        font-medium
                                        tracking-wide
                                        text-slate-400
                                        transition
                                        duration-300
                                        hover:translate-x-1
                                        hover:text-fuchsia-500
                                        dark:text-white/35
                                        dark:hover:text-fuchsia-400
                                    "
                                >
                                    <ChevronRight
                                        size={13}
                                        className="opacity-0 transition group-hover:translate-x-1 group-hover:opacity-100"
                                    />

                                    <span>Qanun və Qaydalar</span>
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* OYUNLAR */}
                    <div>
                        <div className="mb-5 flex items-center gap-2">
                            <span className="h-1.5 w-1.5 rounded-full bg-fuchsia-500 shadow-[0_0_8px_rgba(217,70,239,.8)]" />

                            <h3 className="text-[11px] font-black tracking-[0.2em] text-slate-800 dark:text-white">
                                OYUNLAR
                            </h3>
                        </div>

                        <ul className="space-y-3">
                            {games.map((game) => (
                                <li key={game.path}>
                                    <Link
                                        to={game.path}
                                        className="
                                            group
                                            flex
                                            items-center
                                            gap-2
                                            text-[11px]
                                            font-medium
                                            tracking-wide
                                            text-slate-400
                                            transition
                                            duration-300
                                            hover:translate-x-1
                                            hover:text-fuchsia-500
                                            dark:text-white/35
                                            dark:hover:text-fuchsia-400
                                        "
                                    >
                                        <ChevronRight
                                            size={13}
                                            className="opacity-0 transition group-hover:translate-x-1 group-hover:opacity-100"
                                        />

                                        <span>{game.name}</span>
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* ƏLAQƏ */}
                    <div>
                       <Link to="/phone" className="group mb-5 flex items-center gap-2 transition hover:opacity-80">
                            <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 shadow-[0_0_8px_rgba(52,211,153,.7)]" />

                            <h3 className="text-[11px] font-black tracking-[0.2em] text-slate-800 transition group-hover:text-emerald-500 dark:text-white dark:group-hover:text-emerald-400">
                                ƏLAQƏ
                            </h3>
                        </Link>

                        <p className="text-[12px] leading-7 text-slate-400 dark:text-white/35">
                            Sualınız və ya sifarişiniz varsa bizimlə əlaqə
                            saxlaya bilərsiniz.
                        </p>

                       
                    </div>
                </div>
            </div>

            {/* =====================================================
                COPYRIGHT + SCROLL TOP
            ===================================================== */}

            <div className="relative border-t border-black/[0.06] dark:border-white/[0.06]">
                <div className="mx-auto flex max-w-7xl flex-col gap-5 px-5 py-5 sm:px-6 lg:px-8">

                    {/* Copyright row */}
                    <div className="flex flex-col items-center justify-between gap-4 md:flex-row">

                        <p className="text-center text-[9px] font-medium tracking-[0.12em] text-slate-400 dark:text-white/20 md:text-left">
                            Copyright © 2024 FFQADIR AZ. Bütün hüquqları qorunur.
                        </p>

                        <p className="text-[8px] font-bold tracking-[0.25em] text-fuchsia-500/40">
                            PREMIUM GAMING EXPERIENCE
                        </p>
                    </div>

                    {/* =================================================
                        SCROLL TO TOP
                        Footer daxilində qalır
                    ================================================= */}

                    <div className="flex w-full justify-center md:justify-end">

                        <button
                            type="button"
                            onClick={scrollToTop}
                            aria-label="Yuxarı qalx"
                            className="
                                group
                                relative
                                flex
                                h-11
                                w-11
                                items-center
                                justify-center
                                rounded-full
                                border
                                border-slate-300
                                bg-slate-100
                                text-slate-600
                                shadow-sm
                                transition-all
                                duration-300

                                hover:-translate-y-1
                                hover:border-fuchsia-400
                                hover:bg-fuchsia-50
                                hover:text-fuchsia-500
                                hover:shadow-[0_8px_25px_rgba(217,70,239,0.20)]

                                dark:border-white/10
                                dark:bg-white/[0.04]
                                dark:text-white/60

                                dark:hover:border-fuchsia-500/40
                                dark:hover:bg-fuchsia-500/[0.08]
                                dark:hover:text-fuchsia-400
                                dark:hover:shadow-[0_8px_30px_rgba(217,70,239,0.22)]
                            "
                        >
                            <ArrowUp
                                size={18}
                                strokeWidth={1.8}
                                className="
                                    relative
                                    z-10
                                    transition-transform
                                    duration-300
                                    group-hover:-translate-y-0.5
                                "
                            />

                            {/* subtle fuchsia glow */}
                            <span
                                className="
                                    pointer-events-none
                                    absolute
                                    inset-0
                                    rounded-full
                                    bg-fuchsia-500/10
                                    opacity-0
                                    blur-md
                                    transition-opacity
                                    duration-300
                                    group-hover:opacity-100
                                "
                            />
                        </button>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
